import type { IStorage } from "@whatslly/commons/storage.constants";
import { STORAGE } from "@whatslly/commons/storage.constants";
import { postJSON } from "@whatslly/commons/apiUtils";
import type { SurveillanceSettings } from "@whatslly/types/surveillance/SurveillancePolicy";

export class UpdateSurveillancePoliciesService {
  async checkLastUpdate(storage: IStorage, fetchMethod: any, notifyBlockMessaging: () => Promise<void>) {
    const userLastUpdate = await storage.get(STORAGE.USER_LAST_SURVEILLANCE_POLICIES_UPDATE);
    const { etoken, whatsllyPod } = await storage.get([STORAGE.ETOKEN_KEY, STORAGE.POD_KEY]);
    if (!etoken || etoken === "false") {
      return;
    }
    try {
      const response = await postJSON({
        urlSuffix: "/integrations/surveillance/get-latest-policies",
        pod: whatsllyPod,
        body: JSON.stringify({
          userLastSurveillancePoliciesUpdate: userLastUpdate,
        }),
        etoken,
        fetchMethod,
      });
      const body = await response.json();
      if (!body.success) return;
      this.updatePolicies(storage, body.surveillanceSettings, notifyBlockMessaging);
    } catch {
      return;
    }
  }

  async updatePolicies(storage: IStorage, settings: SurveillanceSettings, notifyBlockMessaging: () => Promise<void>) {
    await storage.set(STORAGE.SURVEILLANCE_SETTINGS, settings);
    await storage.set(STORAGE.USER_LAST_SURVEILLANCE_POLICIES_UPDATE, Date.now());
    await notifyBlockMessaging();
  }

  async removeStorageLastSurveillancePoliciesUpdate(storage: IStorage) {
    await storage.remove(STORAGE.USER_LAST_SURVEILLANCE_POLICIES_UPDATE);
  }

  async updateStorageLastSurveillancePoliciesUpdate(storage: IStorage) {
    await storage.set(STORAGE.USER_LAST_SURVEILLANCE_POLICIES_UPDATE, String(Date.now()) as unknown as number);
  }
}
export const updateSurveillancePoliciesService = new UpdateSurveillancePoliciesService();
